module.exports = __webpack_public_path__ + "static/media/placeholder1920.46f03806.jpg";